export default __webpack_public_path__ + "locales/ro/UploadPanel.json?hash=527ae2384416c99a0baa300f65138684";